import MegaMenu from './MegaMenu';

const $ = jQuery.noConflict();
const header = $('.main-header');
const subnavWrapper = $('.main-header__subnav-wrapper');
let lastPosition = 0;

const stickyHeaderToggle = () => {
    if ( window.scrollY <= header.outerHeight() ) { //Default display

        header.removeClass('main-header--sticky');
        header.removeClass('main-header--sticky-full');

        if ( window.matchMedia('(min-width: 1200px)').matches ) {
            subnavWrapper.slideDown(200);
        }

    } else if ( lastPosition > window.scrollY ) { //Scroll Up
        header.addClass('main-header--sticky-full');

    } else { //Scroll down
        header.addClass('main-header--sticky');

        if ( window.matchMedia('(min-width: 1200px)').matches ) {
            subnavWrapper.slideUp(200);
        }

        if ( window.scrollY > window.innerHeight / 1.5 ) {
            header.removeClass('main-header--sticky-full');

            MegaMenu.constructor.hideMegaMenu();
        } else {
            header.addClass('main-header--sticky-full');
        }
    }

    lastPosition = window.scrollY;
}

export default stickyHeaderToggle;